import { DependencyList } from 'react';
import { useEffect } from 'react';

/**
 * An effect that will be called when browser is about to unload the page.
 * You can use this to warn the user about unsaved changes.
 *
 * @param unloadFn
 * @param deps
 */
export function useUnloadEffect(
  unloadFn: (event: BeforeUnloadEvent) => void,
  deps: DependencyList,
): void {
  return useEffect(() => {
    window.addEventListener('beforeunload', unloadFn);
    return () => {
      window.removeEventListener('beforeunload', unloadFn);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, unloadFn]);
}
